import * as THREE from 'three';

/** Boost saturation and tame lightness so pastel DB pole colors read vividly on blobs (chat + landing). */
export function enhanceColorVisibility(hexColor) {
  const color = new THREE.Color(hexColor);
  const hsl = { h: 0, s: 0, l: 0 };
  color.getHSL(hsl);

  hsl.s = Math.min(1, Math.max(hsl.s, 0.68));
  hsl.l = Math.min(0.62, Math.max(0.3, hsl.l - 0.08));

  const enhanced = new THREE.Color();
  enhanced.setHSL(hsl.h, hsl.s, hsl.l);
  return `#${enhanced.getHexString()}`;
}
